import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ColorPickerComponent, ColorPickerDirective } from 'ngx-color-picker';
import { DndModule } from 'ngx-drag-drop';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxFileDropModule } from 'ngx-file-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { IconPreloaderService } from '../services/icon-preloader.service';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import {
	faAngleLeft,
	faAngleRight,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCompressAlt,
	faCube,
	faDownload,
	faEllipsisH, faExclamation,
	faExpandAlt, faEye,
	faGlobe, faImage, faLongArrowAltRight,
	faMinus, faPencilAlt,
	faPlus,
	faSpinner,
	faTimes, faTimesCircle as farTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
	faCalendarAlt,
	faCheckCircle,
	faSave,
	faTimesCircle as fasTimesCircle
} from '@fortawesome/free-regular-svg-icons';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		TranslateModule,
		FormsModule,
		MaterialModule,
		FontAwesomeModule,
        ColorPickerComponent,
        ColorPickerDirective,
		DndModule,
		InfiniteScrollModule,
		NgxFileDropModule,
		DragDropModule,
		NgxSkeletonLoaderModule.forRoot(),
		AngularSvgIconModule.forRoot(),
		TableVirtualScrollModule,
		ScrollingModule,
		VirtualScrollerModule,
		ReactiveFormsModule,
		OverlayModule,
		MarkdownModule.forRoot()
	],
	exports: [
		CommonModule,
		RouterModule,
		TranslateModule,
		FormsModule,
		MaterialModule,
		FontAwesomeModule,
		ColorPickerComponent,
		ColorPickerDirective,
		DndModule,
		InfiniteScrollModule,
		NgxFileDropModule,
		DragDropModule,
		NgxSkeletonLoaderModule,
		AngularSvgIconModule,
		TableVirtualScrollModule,
		ScrollingModule,
		VirtualScrollerModule,
		ReactiveFormsModule,
		OverlayModule
	],
    providers: [
        IconPreloaderService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => inject(IconPreloaderService).initialize()),
    ]
})
export class DependencyModule {

	constructor(library: FaIconLibrary) {
		library.addIcons(
			faChevronLeft as IconDefinition,
			faChevronRight as IconDefinition,
			faChevronUp as IconDefinition,
			faChevronDown as IconDefinition,
			faAngleLeft as IconDefinition,
			faAngleRight as IconDefinition,
			faMinus as IconDefinition,
			faPlus as IconDefinition,
			faDownload as IconDefinition,
			faGlobe as IconDefinition,
			faExpandAlt as IconDefinition,
			faCompressAlt as IconDefinition,
			faTimes as IconDefinition,
			faCube as IconDefinition,
			faSpinner as IconDefinition,
			faEllipsisH as IconDefinition,
			faLongArrowAltRight as IconDefinition,
			faExclamation as IconDefinition,
			faEye as IconDefinition,
			faPencilAlt as IconDefinition,
			faImage as IconDefinition,
			farTimesCircle as IconDefinition,
			faCalendarAlt as IconDefinition,
			faCheckCircle as IconDefinition,
			fasTimesCircle as IconDefinition,
			faSave as IconDefinition
		);
	}
}
